// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Appointments Calendar only. Selectors are namespaced so Dashboard/Patients/Chart stay unchanged. */

.emr-apt-cal,
.emr-apt-cal *,
.emr-apt-cal *::before,
.emr-apt-cal *::after,
.emr-apt-cal-popper,
.emr-apt-cal-popper *,
.emr-apt-cal-popper *::before,
.emr-apt-cal-popper *::after,
.emr-apt-dialog,
.emr-apt-dialog *,
.emr-apt-dialog *::before,
.emr-apt-dialog *::after {
  border-radius: 0 !important;
}

.emr-apt-cal-shell,
.emr-apt-cal-main {
  background-color: #E5F0FF !important;
}

.emr-apt-cal {
  background-color: #E5F0FF;
}

.emr-apt-cal .emr-apt-surface {
  border-radius: 0 !important;
}

.emr-apt-cal button,
.emr-apt-cal [data-testid="appointment-calendar-location"] {
  border-radius: 0 !important;
}

.emr-apt-cal [data-testid="appointments-table"] {
  border-radius: 0;
  min-width: 1080px;
}

.emr-apt-cal [data-testid="appointments-table"] [class*="inline-flex"],
.emr-apt-dialog [class*="inline-flex"] {
  border-radius: 0 !important;
}

.emr-apt-dialog {
  border-radius: 0 !important;
}

.emr-apt-dialog button {
  border-radius: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/emr-appointments-calendar.css"],"names":[],"mappings":"AAAA,qGAAqG;;AAErG;;;;;;;;;;;;EAYE,2BAA2B;AAC7B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":["/* Appointments Calendar only. Selectors are namespaced so Dashboard/Patients/Chart stay unchanged. */\n\n.emr-apt-cal,\n.emr-apt-cal *,\n.emr-apt-cal *::before,\n.emr-apt-cal *::after,\n.emr-apt-cal-popper,\n.emr-apt-cal-popper *,\n.emr-apt-cal-popper *::before,\n.emr-apt-cal-popper *::after,\n.emr-apt-dialog,\n.emr-apt-dialog *,\n.emr-apt-dialog *::before,\n.emr-apt-dialog *::after {\n  border-radius: 0 !important;\n}\n\n.emr-apt-cal-shell,\n.emr-apt-cal-main {\n  background-color: #E5F0FF !important;\n}\n\n.emr-apt-cal {\n  background-color: #E5F0FF;\n}\n\n.emr-apt-cal .emr-apt-surface {\n  border-radius: 0 !important;\n}\n\n.emr-apt-cal button,\n.emr-apt-cal [data-testid=\"appointment-calendar-location\"] {\n  border-radius: 0 !important;\n}\n\n.emr-apt-cal [data-testid=\"appointments-table\"] {\n  border-radius: 0;\n  min-width: 1080px;\n}\n\n.emr-apt-cal [data-testid=\"appointments-table\"] [class*=\"inline-flex\"],\n.emr-apt-dialog [class*=\"inline-flex\"] {\n  border-radius: 0 !important;\n}\n\n.emr-apt-dialog {\n  border-radius: 0 !important;\n}\n\n.emr-apt-dialog button {\n  border-radius: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
